var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-list_image"},[_c('strong',[_vm._v(_vm._s(_vm.message))]),_c('img',{attrs:{"src":require("../assets/notfound.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }